import { useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import { ApiError } from '../lib/api'
import { Button } from '../components/ui/Button'
import { Field } from '../components/ui/Field'
import { Input } from '../components/ui/Input'

export default function Login() {
  const { user, login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (user) return <Navigate to="/" replace />

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(email, password)
      navigate((location.state as { from?: string } | null)?.from ?? '/', { replace: true })
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Không kết nối được máy chủ')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-cream p-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-card border border-border bg-white p-7 shadow-card">
        <div className="mb-6 flex items-center gap-3">
          <img src="/logo.png" alt="" className="size-11 rounded-full object-cover" />
          <div>
            <h1 className="font-heading text-lg font-bold text-ink">Nhà Nhỏ</h1>
            <p className="text-xs uppercase tracking-wider text-ink-muted">Đăng nhập quản trị</p>
          </div>
        </div>
        <div className="space-y-4">
          <Field label="Email" required>
            <Input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
          </Field>
          <Field label="Mật khẩu" required error={error ?? undefined}>
            <Input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </Field>
          <Button type="submit" className="w-full" loading={busy}>Đăng nhập</Button>
        </div>
      </form>
    </div>
  )
}
